import { useState } from 'react'
import { useMediaQuery } from 'react-responsive'

const useHomeCard = () => {
  const [isHovering, setIsHovering] = useState(false)
  const isSmallDevice = useMediaQuery({
    query: '(max-width: 1200px)',
  })
  const handleMouseEnter = () => {
    if (!isSmallDevice) {
      setIsHovering(true)
    }
  }

  const handleMouseLeave = () => {
    if (!isSmallDevice) {
      setIsHovering(false)
    }
  }

  const containerClass = !isSmallDevice ? 'flip-container' : ''

  return { isHovering, containerClass, handleMouseLeave, handleMouseEnter }
}

export default useHomeCard
